
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    introText: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    themeColor: {
      type: String,
      default: '#3A7187',
    },
    centered: {
      type: Boolean,
    },
    extraPb: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    },
  },
};
